import(/* webpackMode: "eager" */ "/tmp/8de6e09203c6a52/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de6e09203c6a52/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de6e09203c6a52/app/[locale]/branches/industries-overview.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de6e09203c6a52/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de6e09203c6a52/node_modules/next/dist/client/link.js");
